import DocumentReviewSection from "./DocumentReviewSection";

export default DocumentReviewSection;



// WEBPACK FOOTER //
// ./src/components/QuickReview/DocumentReviewSection/index.js